var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',[_c('SubHeader',{attrs:{"title":_vm.errorTitle}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }